export default "__VITE_ASSET__DCg7i_$X__"